var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-jumbotron",
        {
          attrs: {
            gradient: _vm.gradient,
            light: "",
            src: "/static/images/13.jpg",
            height: "82vh"
          }
        },
        [
          _c(
            "v-container",
            { attrs: { "fill-height": "" } },
            [
              _c(
                "v-layout",
                { attrs: { "align-center": "" } },
                [
                  _c(
                    "v-flex",
                    [
                      _c("h3", { staticClass: "display-3 title1" }, [
                        _vm._v("Welcome")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "headline title2" }, [
                        _vm._v("Looks like you do not have any submissions...")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "title mb-3 middleText1" }, [
                        _vm._v("Let's submit your art reviews!")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-0",
                          attrs: {
                            color: "primary",
                            depressed: "",
                            large: "",
                            router: "",
                            to: "/business_dashboard"
                          }
                        },
                        [
                          _vm._v(
                            "\n            Upload your submissions\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "300" },
          model: {
            value: _vm.loading,
            callback: function($$v) {
              _vm.loading = $$v
            },
            expression: "loading"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-actions", [
                _c(
                  "div",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { align: "center" }
                  },
                  [
                    _c("v-progress-circular", {
                      attrs: { size: 70, indeterminate: "", color: "amber" },
                      model: {
                        value: _vm.loading,
                        callback: function($$v) {
                          _vm.loading = $$v
                        },
                        expression: "loading"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ee86c36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ee86c36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/submissions_empty.vue
// module id = null
// module chunks = 